import LogoImg from 'assets/images/header_logo.png';
import { IconManager } from 'components/_universal/IconManager/IconManager';
import { THEME_VARIANT } from 'shared/constants';
import paths from 'shared/paths';
import { ProfileDropdown } from '../ProfileDropdown/ProfileDropdown';
import { HeaderLink, HeaderWrapper, Logo } from './Header.styled';

export interface IProps {}

export const Header = ({}: IProps) => {
    return (
        <HeaderWrapper>
            <HeaderLink to={paths.home}>
                {THEME_VARIANT === 'DOCTOR' ? (
                    <Logo src={LogoImg} />
                ) : (
                    <IconManager cursorPointer name={'LogoIcon'} />
                )}
            </HeaderLink>
            <ProfileDropdown />
        </HeaderWrapper>
    );
};
